import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.1395 13.572C14.3092 13.572 16.0681 11.8131 16.0681 9.64342C16.0681 7.47373 14.3092 5.71484 12.1395 5.71484C9.96982 5.71484 8.21094 7.47373 8.21094 9.64342C8.21094 11.8131 9.96982 13.572 12.1395 13.572Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M5.42969 19.699C6.13092 18.5479 7.11647 17.5966 8.29159 16.9366C9.4667 16.2764 10.7919 15.9297 12.1397 15.9297C13.4875 15.9297 14.8127 16.2764 15.9878 16.9366C17.1629 17.5966 18.1484 18.5479 18.8497 19.699",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.1401 22.2147C17.7813 22.2147 22.3544 17.6417 22.3544 12.0004C22.3544 6.35923 17.7813 1.78613 12.1401 1.78613C6.49887 1.78613 1.92578 6.35923 1.92578 12.0004C1.92578 17.6417 6.49887 22.2147 12.1401 22.2147Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }